<template>
    <div class="vue-root">
    <div ref="lightbox" class="lightbox d-none">
        <iframe class="lightbox-frame" style="border:none;" width="100%" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" scrolling="no" height="100%"></iframe>
        <button @click="closeLightbox" type="button" class="lightbox-controls close position-absolute" data-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="14.811" height="14.811" viewBox="0 0 14.811 14.811">
                <path id="close.2" d="M14.811.873,13.938,0,7.405,6.533.873,0,0,.873,6.533,7.405,0,13.938l.873.873L7.405,8.278l6.533,6.533.873-.873L8.278,7.405Z"/>
            </svg>
        </button>
    </div>
    <div class="position-relative">
        <div class="position-absolute w-100 d-flex justify-content-center top-0 left-0 upperOverlay">
            <div class="container px-4 px-xl-3">
                <a class="backBtn d-inline-flex align-items-center" href="#" onclick="history.back()">
                    <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="4" height="5.419" viewBox="0 0 4 5.419">
                        <path id="play-button" d="M.056,2.6,3.8.023A.129.129,0,0,1,4,.129V5.29a.129.129,0,0,1-.2.106L.056,2.816a.129.129,0,0,1,0-.212Z" opacity="0.6" />
                    </svg>
                    <p>{{t('pagination.previous')}}</p>
                </a>
            </div>
            <div class="iconContainer d-flex flex-column position-absolute right-0 top-0">
                <img v-for="icon in iconsRight" :src="icon.path" loading="lazy" />
            </div>
        </div>
        <div class="w-100 d-flex justify-content-center bg-light-grey">
            <div class="container px-4 px-xl-3">
                <div class="row">
                    <div class="col-12 col-md-5 productdetail__details pr-3 pr-xl-5 pb-3">
                        <h2>{{product.subtitle}}</h2>
                        <h1 class="pt-1">{{product.title}}</h1>
                        <h3 class="pt-3 pt-md-5">{{t('product.from')}} {{product.priceFormatted}}</h3>
                        <h4>{{t('product.infoprice')}}</h4>
                        <p class="pt-2 pt-md-5" v-html="product.shortDescription"></p>
                        <div class="d-flex btnRow px-4 py-3 px-sm-0 py-sm-0 bg-light-grey w-100 w-sm-auto">
                            <!-- //disabled for now
                            <button href="#" class="btn btn-primary mr-2">
                                <span>{{t('product.configure')}}</span>
                            </button>
                            -->
                            <button @click="addProductToCompare" href="#" class="d-none d-sm-block btn btn-second" v-if="compareEnabled">
                                <span>{{t('product.compare')}}</span>
                            </button>
                            <button @click="addProductToCompare" href="#" class="mobileVersion d-flex d-sm-none btn btn-second justify-content-center align-items-center" v-if="compareEnabled">
                                <span>
                                    <span>{{t('product.compare')}}</span>
                                </span>
                            </button>

                            <button @click="openConfiguratorUrl" href="#" class="d-none d-sm-block btn btn-second" v-if="configuratorUrl">
                                <span>{{t('product.configurator_label')}}</span>
                            </button>
                            <button @click="openConfiguratorUrl" href="#" class="mobileVersion d-flex d-sm-none btn btn-second justify-content-center align-items-center" v-if="configuratorUrl">
                                <span>
                                    <span>{{t('product.configurator_label')}}</span>
                                </span>
                            </button>

                        </div>
                    </div>
                    <div class="col-12 col-md-7 productdetail__pointer"
                        @click="closePointerPopup"
                    >
                        <div class="position-relative">
                            <img class="w-100" :src="image" loading="lazy">
                            <!-- Batches -->
                            <template 
                                v-if="product.url3d"
                            >
                                <div
                                    class="d-none d-md-flex position-absolute threeDPin button-3d lightbox-open"
                                    @click="openLightbox(product.url3d)"
                                >
                                    <inline-svg :src="'/img/threeDPin.svg'"/>
                                </div>
                                <div class="d-flex d-md-none position-absolute threeDPin"
                                    @click="openLightbox(product.url3d)"
                                >
                                    <inline-svg :src="'/img/threeDPinSmall.svg'" />
                                </div>
                            </template>
                            <!-- Detail Pins -->
                            <template v-for="pointer in pointers">
                            <div class="position-absolute productDetailPin"
                                 v-bind:style="{top: pointer.y + '%', left: pointer.x + '%'}"
                                 @click="openPointerPopup"
                            >
                                <inline-svg :src="'/img/productDetailPin.svg'" />
                                <div class="position-absolute productDetailPin__content">
                                    <template v-if="getPointerImageByIndex(pointer.bild_nr)" >
                                        <img :src="getPointerImageByIndex(pointer.bild_nr)" loading="lazy" />
                                    </template>
                                    <h4>{{pointer.label}}</h4>
                                    <p class="text-white p-3">{{pointer.text}}</p>
                                </div>
                            </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 d-flex justify-content-center">
        <div class="container px-4 px-xl-3">
            <div class="tabSwitcher d-flex flex-wrap">
                <button
                    v-for="(buttonTab, key) in tabs"
                    class="pb-2 mb-4"
                    :class="{'active': activeTab === key}"
                    @click="activeTab = key"
                >{{ buttonTab.btnName }}</button>
            </div>
            <div class="tabContainer position-relative">
                <template v-if="tabs.description && activeTab == 'description'">
                    <div class="tabContainer__inner row">
                        <h2 
                            v-if="tabs.description.headline"
                            class="col-12"
                            v-text="tabs.description.headline"
                        ></h2>
                        <div class="col-12 col-lg-7">
                            <div
                                v-if="tabs.description.maintext"
                                class="mainText"
                                v-html="tabs.description.maintext"
                            ></div>
                            <div
                                class="pt-2 mt-2 mt-lg-4 mb-4 pt-xl-0 d-flex flex-column flex-md-row additionalLinks"
                                v-if="tabs.description.urls"
                            >
                                <a
                                    class="btn btn-second mr-0 mr-md-2 mb-2 mb-md-0 w-100 w-sm-auto"
                                    v-for="(url) in tabs.description.urls"
                                    v-if="url.href"
                                    :href="url.href"
                                    target="_blank"
                                >
                                    {{ url.label }}
                                </a>
                            </div>
                        </div>
                        <div class="col-12 col-lg-5 additionalInfo">
                            <h3 class="pb-2" v-if="tabs.description.materialAndTechnik">{{t('product.material_technic')}}</h3>
                            <div class="pb-5" v-html="tabs.description.materialAndTechnik"></div>
                            <h3 class="pb-2" v-if="tabs.description.manual">{{t('product.operation')}}</h3>
                            <div class="pb-5 pb-lg-2" v-html="tabs.description.manual"></div>
                        </div>
                        <div class="col-12 spacer"></div>
                        <div class="col-12 d-flex d-xl-none">
                            <div class="borderBottom"></div>
                        </div>
                        <div class="iconDetails">
                            <div
                                class="iconDetails__item pr-3"
                                v-for="(iconTab, index) in tabs.description.iconInfos"
                            >
                                <div class="d-flex flex-wrap pb-4">
                                    <div
                                        class="iconDetails__item__icon"
                                        v-for="(icon) in iconTab.icons"
                                        :style="{ 'background-image': 'url(/assets/productdetail/images/'+ icon +')' }"
                                    ></div>
                                </div>
                                <h3 class="pb-2">{{ iconTab.title }}</h3>
                                <p class="pb-1">{{ iconTab.description }}</p>
                                <template v-if="iconTab.popup.extra_description">
                                    <p class="pb-1">{{ iconTab.popup.extra_description }}</p>
                                </template>
                                <template v-if="iconTab.popup">
                                    <button
                                        class="pb-2"
                                        @click="openPopup(index, iconTab.popup.url)"
                                    >
                                        <span>{{ iconTab.popup.label }}</span>
                                    </button>
                                    <div
                                        class="iconDetails__item__popup bg-white position-fixed h-100 w-100 d-flex flex-column justify-content-between"
                                        :class="{'active': activeIconTab == index}"
                                    >
                                        <div class="iconDetails__item__popup__upper d-flex">
                                            <svg class="mr-5" id="Information" xmlns="http://www.w3.org/2000/svg" width="13.829" height="13.829" viewBox="0 0 13.829 13.829">
                                                <g id="Border" fill="#f8f8f8">
                                                    <path d="M 6.914713859558105 13.57942390441895 C 3.239783763885498 13.57942390441895 0.2500038743019104 10.58964347839355 0.2500038743019104 6.914713859558105 C 0.2500038743019104 3.239783763885498 3.239783763885498 0.2500038743019104 6.914713859558105 0.2500038743019104 C 10.58964347839355 0.2500038743019104 13.57942390441895 3.239783763885498 13.57942390441895 6.914713859558105 C 13.57942390441895 10.58964347839355 10.58964347839355 13.57942390441895 6.914713859558105 13.57942390441895 Z" stroke="none" />
                                                    <path d="M 6.914713859558105 0.5000038146972656 C 3.377634048461914 0.5000038146972656 0.5000038146972656 3.377634048461914 0.5000038146972656 6.914713859558105 C 0.5000038146972656 10.4517936706543 3.377634048461914 13.32942390441895 6.914713859558105 13.32942390441895 C 10.4517936706543 13.32942390441895 13.32942390441895 10.4517936706543 13.32942390441895 6.914713859558105 C 13.32942390441895 3.377634048461914 10.4517936706543 0.5000038146972656 6.914713859558105 0.5000038146972656 M 6.914713859558105 3.814697265625e-06 C 10.73360443115234 3.814697265625e-06 13.82942390441895 3.095824241638184 13.82942390441895 6.914713859558105 C 13.82942390441895 10.73360443115234 10.73360443115234 13.82942390441895 6.914713859558105 13.82942390441895 C 3.095824241638184 13.82942390441895 3.814697265625e-06 10.73360443115234 3.814697265625e-06 6.914713859558105 C 3.814697265625e-06 3.095824241638184 3.095824241638184 3.814697265625e-06 6.914713859558105 3.814697265625e-06 Z" stroke="none" fill="#e60014" />
                                                </g>
                                                <path id="Icon" d="M33.916,5.78l-.091.37q-.407.161-.65.245a1.715,1.715,0,0,1-.564.084,1.125,1.125,0,0,1-.767-.241.779.779,0,0,1-.274-.611,2.161,2.161,0,0,1,.02-.294q.021-.15.066-.339L32,3.793q.045-.173.076-.327a1.422,1.422,0,0,0,.031-.282.435.435,0,0,0-.095-.321.537.537,0,0,0-.363-.091.951.951,0,0,0-.27.041c-.092.027-.171.054-.238.078l.091-.37q.334-.136.638-.232a1.909,1.909,0,0,1,.577-.1,1.1,1.1,0,0,1,.755.237.786.786,0,0,1,.265.615c0,.052-.006.144-.018.276a1.843,1.843,0,0,1-.068.362l-.338,1.2a3.18,3.18,0,0,0-.074.33,1.7,1.7,0,0,0-.033.28.4.4,0,0,0,.106.325.6.6,0,0,0,.37.086,1.068,1.068,0,0,0,.28-.043A1.563,1.563,0,0,0,33.916,5.78ZM34,.757a.7.7,0,0,1-.236.533.8.8,0,0,1-.569.22.814.814,0,0,1-.572-.22.7.7,0,0,1-.239-.533.706.706,0,0,1,.239-.535.845.845,0,0,1,1.142,0A.707.707,0,0,1,34,.757Z" transform="translate(-25.897 3.436)" fill="#e60014" />
                                            </svg>
                                            <h3>{{t('product.info')}}</h3>
                                        </div>
                                        <div class="iconDetails__item__popup__middle">
                                            <!-- RTE body -->
                                            <h2>Befestigungslösungen</h2>
                                            <h3>Zu einem Sonnenschirm gehört auch die richtige Befestigungslösung. Auf der sicheren Seite sind Besitzer:innen von Glatz-Schirmen , wenn sie das Original-Zubehör für eine optimale Befestigung und Standsicherheit verwenden.</h3>
                                            <p>Nur so sind die Stabilität gemäss unsere Leistungsversprechen (wie zum Beispiel die Windfestigkeit und die Glatz-Gewährleistung garantiert. Je nach Situation und Einsatzort bietet Glatz verschiedene Befestigungslösungen. Beachten Sie bitte die von Glatz empfohlenen Befestigungsmöglichkeiten inklusive dem Mindestgewicht für das jeweilige Schirmmodell (Übersicht Schirme Befestigungs-möglichkeiten direkt auf der Seite:)</p>
                                            <h4>Wann wird welche Befestigung empfohlen?</h4>
                                            <p>Hat der Sonnenschirm einen festen Platz auf der Terrasse, der sich nicht ändert? Dann empfehlen wir Ihnen eine fest einbetonierte Bodenhülse, damit kein Sockel stört und zur Stolperfalle wird. Insbesondere für Gastronomiebetriebe ist diese Art der Befestigung sehr sinnvoll. <br><br>Sie möchten Ihre Beschattung dem täglichen Sonnenverlauf anpassen? Dann ist ein Sockel mit Rollen für Sie die optimale Lösung. <br><br>Steht Ihr Sonnenschirm die meiste Zeit am gleichen Ort und behindert keine Laufwege? Dann empfehlen wir Ihnen, als Sonnenschirmständer einen Sockel zu verwenden. Sockel gibt es in verschiedenen Abmessungen, Gewichten und Materialien.
                                            </p>
                                            <a href="#">
                                                <p>Hier erfahren Sie mehr</p>
                                            </a>
                                        </div>
                                        <div class="w-100 iconDetails__item__popup__closer">
                                            <button
                                                @click="closePopup"
                                                class="d-flex w-100 py-4 justify-content-center align-items-center"
                                            >
                                                <span>{{t('product.close')}}</span>
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="tabs.technicalDetails && activeTab == 'technicalDetails'">
                    <div class="tabContainer__inner">
                        <img :src="technicalImage" width="100%" loading="lazy"/>
                    </div>
                </template>
                <template v-else-if="tabs.colors && activeTab == 'colors'">
                    <div class="tabContainer__inner colors row">
                    <template v-for="color in colors">
                        <div class="col-6 col-md-4 col-lg-3">
                            <a
                                class="color"
                                href="#"
                                @click="changeImage(color.path)"
                            >
                                <img :src="mediaPath + color.path" loading="lazy" />
                                <h2 class="pt-2">{{color.subtitle}}</h2>
                                <div class="pt-2">{{color.title}}</div>
                            </a>
                        </div>
                    </template>
                    </div>
                </template>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import gql from 'fake-tag';
import { FireI18n } from 'fire-js-i18n';
import InlineSvg from 'vue-inline-svg';
import {eventBus} from 'fire-vue-core';

export default {
    name: 'ProductDetail',
    data: () => ({
        tabs: [],
        activeTab: 'description',
        activeIconTab: null,
        lightbox: null,
        iconsRight: [],
        pointers: [],
        pointerImages: [],
        colors: [],
        technicalDetail: '',
        product: [],
        image: '',
        technicalImage: '',
        compareProducts: []
    }),
    components: {
        'inline-svg': InlineSvg
    },
    props: {
        ptabs: [],
        piconsRight: [],
        pproduct: [],
        ppointers: [],
        ppointerimages: [],
        pcolors: [],
        mediaPath: '',
        configuratorUrl: false,
        compareEnabled: false
    },
    methods: {
        t(key, options)
        {
            return FireI18n.t(key, options);
        },
        openPopup(index, url) {
            if (url!= '#') {
                window.location.href = url;
            } else
            {
                this.activeIconTab = index;
                document.body.classList.add('productdetail-popup-open');
            }
        },
        closePopup() {
            this.activeIconTab = null;
            document.body.classList.remove('productdetail-popup-open');
        },
        changeImage(img)
        {
            this.image = this.mediaPath + img;
        },
        getPointerImageByIndex(i)
        {
            if (this.pointerImages[i])
            {
                return this.pointerImages[i];
            }
        },
        openLightbox(url) {
            this.lightbox.querySelector('.lightbox-frame').setAttribute('src', url);
            setTimeout(() => {
                this.lightbox.classList.remove('d-none');
                this.lightbox.classList.add('d-flex');
                document.body.classList.add('lightbox-open');
            }, 500);

        },
        closeLightbox() {
            this.lightbox.classList.remove('d-flex');
            this.lightbox.classList.add('d-none');
            document.body.classList.remove('lightbox-open');
        },
        openPointerPopup(event) {
            const target = event.target.classList.contains('productDetailPin') ? event.target : event.target.closest('.productDetailPin');
            target.classList.toggle('open');

        },
        closePointerPopup(event) {
            const onPinClicked = event.target.closest('.productDetailPin');
            if (!onPinClicked)
            {
                [...document.querySelectorAll('.productDetailPin')].map((el) => {
                    el.classList.remove('open');
                });
            }
        },
        handleResizePinOverflow(element) {
            const pinBox = element.querySelector('.productDetailPin__content');
            // console.log(element.offsetLeft, pinBox.offsetWidth)
            // console.log(window.innerWidth, element.offsetLeft + pinBox.offsetWidth)
            if (window.innerWidth < element.offsetLeft + pinBox.offsetWidth) {
                element.classList.add('align-right');
                element.classList.remove('align-center');
            } else if (element.offsetLeft < pinBox.offsetWidth) {
                element.classList.add('align-center');
                element.classList.remove('align-right');
            } else {
                element.classList.remove('align-right', 'align-center');
            }
        },
        onResizePinOverflow() {
            window.addEventListener('resize', () => {
                [...document.querySelectorAll('.productDetailPin')].map(this.handleResizePinOverflow);
                this.fixFooterHeight();
            });

        },
        fixFooterHeight() {
            let footer = document.querySelector('.footerStandard.container');
            if (window.innerWidth <=575) {
                footer.style.paddingBottom = "80px";
            } else {
                footer.style.removeProperty("padding-bottom");
            }
        },
        addProductToCompare() {
            if (localStorage.getItem('comparisonProducts')){
                this.compareProducts = JSON.parse(localStorage.getItem('comparisonProducts'));
            }
            if (this.product.shopProductId) {
                if (!this.compareProducts.includes(this.product.shopProductId))
                {
                    this.compareProducts.push(this.product.shopProductId);
                    if(this.compareProducts.length > 3)
                    {
                        this.compareProducts.shift();
                    }
                    let parsed = JSON.stringify(this.compareProducts);
                    localStorage.setItem('comparisonProducts', parsed);
                }
                eventBus.$emit('updateDataCompareAll','popup');
            }
        },
        openConfiguratorUrl() {
          window.open(this.configuratorUrl, '_blank');
        }
    },
    mounted() {
        this.lightbox = this.$refs.lightbox;
        this.closeLightbox();
        this.tabs = this.ptabs;
        this.iconsRight = this.piconsRight;
        this.pointers = this.ppointers;
        this.pointerImages = this.ppointerimages;
        this.colors = this.pcolors;
        this.product = this.pproduct;
        const imageObject = this.product.medias.find(({ targetAttr }) => targetAttr === "image");
        this.image = imageObject ? imageObject.path : '';
        const technicalImageObject = this.product.medias.find(({ targetAttr }) => targetAttr === "technical_detail");
        this.technicalImage = technicalImageObject ? technicalImageObject.path : '';
        this.onResizePinOverflow();
        this.fixFooterHeight();
    },
}

</script>
